import { PartialPartner } from "@/common/partner/types";

export function getProgramSearchUrl(partners: PartialPartner[]): string {
  const partnersForProgramSearch = partners.map((partner) => partner.name);
  const searchUrl = new URL("/search", window.location.origin);
  searchUrl.searchParams.set("tab", "program");
  partnersForProgramSearch.forEach((partnerName) => {
    searchUrl.searchParams.append("partner", partnerName);
  });
  return searchUrl.pathname + searchUrl.search;
}
